import { render, staticRenderFns } from "./router-build-option.vue?vue&type=template&id=edea6eee"
import script from "./router-build-option.vue?vue&type=script&lang=js"
export * from "./router-build-option.vue?vue&type=script&lang=js"
import style0 from "./router-build-option.vue?vue&type=style&index=0&id=edea6eee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports